import { FetchState } from 'src/enums/FetchState';

import { SearchRequestData, SearchResponseData } from 'src/services/search/SearchDtos';

import { fetchRequest } from 'src/utils/fetchRequest';

type SearchPromise = Promise<{ data?: SearchResponseData; state: FetchState }>;

export async function searchRequest(formData: SearchRequestData): SearchPromise {
	try {
		const response = await fetchRequest(process.env.NEXT_PUBLIC_SITECORE_HEADLESS_LEARNING_SEARCH || '', formData);

		const data = await response.json();

		if (response.status === 404) {
			return {
				data: {
					Results: null,
					TotalResults: 0,
					TotalPages: 0,
					SpellingSuggestions: data.SpellingSuggestions,
					SpellingCollations: data.SpellingCollations,
				},
				state: FetchState.WARNING,
			};
		}

		if (response.status !== 200) {
			throw response.statusText;
		}

		return { data: data as SearchResponseData, state: FetchState.SUCCESS };
	} catch (error) {
		console.error(error);
		return { state: FetchState.ERROR };
	}
}
